<template>
	<div class="table-lister table-responsive">
		<table>
			<thead>
				<tr>
					<th>ID</th>
					<th>
						<div class="flex start flex-nowrap">Provider</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Last Imported</span>
						</div>
					</th>
					<th>
						<div class="flex start flex-nowrap">
							<span class="th">Last Updated</span>
						</div>
					</th>
					<th v-if="userRoles.includes('dashboard_access.delete')">Action</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="provider in providers">
					<td>{{ provider.id }}</td>
					<td>
						<strong class="article-title">{{ provider.name }}</strong>
						<div class="article-links">
							<span v-if="provider.state" class="badge badge-success">Active</span>
							<span v-if="!provider.state" class="badge badge-danger">Disabled</span>
							<span class="badge badge-default">{{ provider.affiliateType }}</span>
							<span v-if="provider.custom_field" class="badge badge-warning">{{ provider.custom_field }}</span>
							<a v-if="userRoles.includes('dashboard_access.update')"
							   :href="'/' + $selectedSite.slug + '/dashboard/providers/' + provider.id + '/edit'">Edit</a>
						</div>
					</td>
					<td>{{ provider.last_imported }}</td>
					<td>
						{{ provider.updated_at }}
					</td>

					<td v-if="userRoles.includes('dashboard_access.delete')">
						<button @click.prevent="deleteStatsProvider(provider.id)" title="Delete" class="btn btn-icon btn-danger"><i class="fas fa-fw fa-trash"></i></button>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	name: "StatsProviderList",
	props: {
		dataProviders: {
			type: Object
		}
	},
	data() {
		return {
			providers: this.dataProviders,
			userRoles: this.$currentUserRoles,
		}
	},
	methods: {
		deleteStatsProvider: function (id) {
			let vm = this;
			vm.$dialog.confirm('Are you sure you want to delete this Provider?')
				.then((dialog) => {
					axios.delete('/api/' + this.$selectedSite.slug + '/statsProvider/' + id)
						.then(response => {
							vm.$toastr.success('Delete successful.');
							location.reload();
						})
						.catch(errors => {
							dialog.close();
							vm.$toastr.error('Delete failed.');
						});
				})
				.catch(error => {
					vm.$toastr.error('Delete aborted.');
				});
		},
	}
}
</script>

<style scoped>

</style>
